import { AnyAction, combineReducers } from 'redux'
import {
  TOGGLE_CART_PACKAGES,
  TOGGLE_CART_SIDEBAR,
  CART_EMPTY,
  ACCOUNT_ACCESS_SHOW_LOGIN,
  ACCOUNT_ACCESS_SHOW_EMAIL_JOIN,
  ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD,
  ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK,
  SHOW_BRIDGER_PAY_PAYMENT_MODAL,
  ADD_PAYMENT_PROVIDER,
  SHOW_USE_GIFT_CARD_MODAL,
  SHOW_CHANGE_DATE_WARNING_MODAL,
  SHOW_CHANGE_DATE_ADDON_WARNING_MODAL,
  BOOKING_DATE_WARNING_MODAL_OPEN,
  ACCOMMODATION_PRICE_CHANGE_MODAL_OPEN,
  BEDBANK_PRICE_CHANGE_MODAL_OPEN,
  BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN,
  JOURNEY_SOLD_OUT_MODAL_OPEN,
  FLIGHTS_SESSION_EXPIRED_MODAL_OPEN,
  TRAVELLER_NAME_TOO_LONG_MODAL_OPEN,
  JOURNEY_COST_CHANGE_MODAL_OPEN,
  SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL,
  SHOW_ACCOUNT_TAKE_OVER_MODAL,
  SHOW_FLIGHT_REBOOKING_CONDITIONS_MODAL,
  SHOW_CUSTOMER_SIGNATURE_MODAL,
  CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN,
  GENERIC_ORDER_ERROR_MODAL_OPEN,
  AUTH_MODAL_OPEN,
  QUOTE_EMAIL_MODAL_OPEN,
  MODAL_OPEN,
  MODAL_CLOSE,
  ACCOUNT_DROPDOWN_TOGGLE_STANDALONE,
  ACCOUNT_DROPDOWN_TOGGLE,
  REGION_DROPDOWN_TOGGLE,
  EVENTS_DROPDOWN_TOGGLE,
  PHONE_DROPDOWN_TOGGLE,
  TOGGLE_CART_PACKAGE_NIGHTS,
  API_CALL_SUCCESS,
  CLOSE_SOCIAL_WIDGET,
  TOUR_V2_PRICE_CHANGE_MODAL_OPEN,
  JOURNEY_PRICE_CHANGE_MODAL_OPEN,
  HOTEL_PRICE_CHANGE_MODAL_OPEN,
  BUNDLE_PRICE_CHANGE_MODAL_OPEN,
  SHOW_CHECKOUT_CART_MODE_MODAL,
  ACCOUNT_ACCESS_SET_MODE,
  SHOW_PAY_TO_AUTHORISATION_MODAL,
} from 'actions/actionConstants'
import { createReducer } from 'lib/redux/reducerUtils'
import {
  USER_LOGIN,
  USER_REGISTRATION,
  USER_LOGOUT,
} from 'actions/apiActionConstants'

const initialOverlayState: App.UiOverlayState = {
  accountDropdownOpen: false,
  dropdownType: '',
  regionDropdownOpen: false,
  phoneDropdownOpen: false,
  anyAreOpen: false,
  eventsDropdownOpen: false,
}

const initialModalState: App.UiModalState = {
  open: false,
  heading: '',
  message: '',
  modalType: undefined,
  fareUrls: [],
  fareRuleParams: undefined,
  error: {
    open: false,
    heading: '',
    message: '',
  },
  errors: [],
  packageId: undefined,
  cost: undefined,
  refCode: undefined,
  cartItemId: undefined,
  priceChange: undefined,
  price: 0,
  surcharge: 0,
  extraGuestSurcharge: 0,
  paymentProvider: undefined,
  showConfirmationOptions: false,
}

const initialSocialWidgetState: App.UiSocialWidgetState = {
  display: true,
}

function modalType(action: AnyAction): App.ModalType | undefined {
  switch (action.type) {
    case ACCOUNT_ACCESS_SHOW_LOGIN:
    case ACCOUNT_ACCESS_SHOW_EMAIL_JOIN:
    case ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD:
    case ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK:
      return 'accountAccess'
    case SHOW_BRIDGER_PAY_PAYMENT_MODAL:
      return 'bridgerPayPayment'
    case SHOW_USE_GIFT_CARD_MODAL:
      return 'useGiftCard'
    case SHOW_CHANGE_DATE_WARNING_MODAL:
      return 'changeDateWarning'
    case SHOW_CHANGE_DATE_ADDON_WARNING_MODAL:
      return 'changeDateAddonWarning'
    case BOOKING_DATE_WARNING_MODAL_OPEN:
      return 'bookingDateWarning'
    case ACCOMMODATION_PRICE_CHANGE_MODAL_OPEN:
      return 'accommodationPriceChange'
    case HOTEL_PRICE_CHANGE_MODAL_OPEN:
      return 'hotelPriceChange'
    case BUNDLE_PRICE_CHANGE_MODAL_OPEN:
      return 'bundlePriceChange'
    case BEDBANK_PRICE_CHANGE_MODAL_OPEN:
      return 'bedbankPriceChange'
    case BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN:
      return 'bedbankHotelPriceChange'
    case TOUR_V2_PRICE_CHANGE_MODAL_OPEN:
      return 'tourV2PriceChange'
    case JOURNEY_PRICE_CHANGE_MODAL_OPEN:
      return 'journeyPriceChange'
    case JOURNEY_SOLD_OUT_MODAL_OPEN:
      return 'journeySoldOut'
    case FLIGHTS_SESSION_EXPIRED_MODAL_OPEN:
      return 'flightsSessionExpired'
    case JOURNEY_COST_CHANGE_MODAL_OPEN:
      return 'journeyCostChange'
    case SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL:
      return 'bridgerPaymentFailed'
    case SHOW_ACCOUNT_TAKE_OVER_MODAL:
      return 'accountTakenOver'
    case SHOW_FLIGHT_REBOOKING_CONDITIONS_MODAL:
      return 'flightRebookingConditions'
    case CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN:
      return 'cantProcessOrderOnline'
    case GENERIC_ORDER_ERROR_MODAL_OPEN:
      return 'genericOrderError'
    case TRAVELLER_NAME_TOO_LONG_MODAL_OPEN:
      return 'travellerNameTooLongError'
    case QUOTE_EMAIL_MODAL_OPEN:
      return 'quoteEmail'
    case SHOW_CUSTOMER_SIGNATURE_MODAL:
      return 'customerSignature'
    case SHOW_CHECKOUT_CART_MODE_MODAL:
      return 'checkoutCartMode'
    case SHOW_PAY_TO_AUTHORISATION_MODAL:
      return 'payToAuthorisation'
    default:
      return undefined
  }
}

function modalReducer(state = initialModalState, action): App.UiModalState {
  switch (action.type) {
    case ADD_PAYMENT_PROVIDER:
      return {
        ...state,
        ...initialModalState,
        paymentProvider: action.paymentProvider,
      }
    case ACCOUNT_ACCESS_SHOW_LOGIN:
    case ACCOUNT_ACCESS_SHOW_EMAIL_JOIN:
    case ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD:
    case ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK:
    case SHOW_PAY_TO_AUTHORISATION_MODAL:
    case SHOW_CHECKOUT_CART_MODE_MODAL:
      return {
        ...state,
        ...initialModalState,
        open: true,
        modalType: modalType(action),
      }
    case SHOW_USE_GIFT_CARD_MODAL:
      return {
        ...state,
        ...initialModalState,
        open: true,
        modalType: modalType(action),
      }
    case SHOW_BRIDGER_PAY_PAYMENT_MODAL:
      return {
        ...state,
        ...initialModalState,
        open: true,
        modalType: modalType(action),
        message: action.url,
      }
    case AUTH_MODAL_OPEN:
      return {
        ...initialModalState,
        open: true,
        heading: action.data.heading,
        message: action.data.message,
        modalType: modalType(action),
      }
    case BOOKING_DATE_WARNING_MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        error: {
          open: true,
        },
      }
    case JOURNEY_SOLD_OUT_MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        open: true,
      }
    case FLIGHTS_SESSION_EXPIRED_MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        open: true,
      }
    case TRAVELLER_NAME_TOO_LONG_MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        open: true,
      }
    case GENERIC_ORDER_ERROR_MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        open: true,
        errors: action.data.errors,
      }
    case CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        open: true,
        refCode: action.data.refCode,
      }
    case JOURNEY_COST_CHANGE_MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        open: true,
        message: action.data.message,
        cost: action.data.cost,
      }
    case SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL:
      return {
        ...initialModalState,
        modalType: modalType(action),
        paymentProvider: action.data.paymentProvider,
        error: {
          open: true,
        },
      }
    case SHOW_ACCOUNT_TAKE_OVER_MODAL:
      return {
        ...initialModalState,
        modalType: modalType(action),
        open: true,
      }
    case SHOW_FLIGHT_REBOOKING_CONDITIONS_MODAL:
      return {
        ...initialModalState,
        open: true,
        modalType: modalType(action),
      }
    case QUOTE_EMAIL_MODAL_OPEN:
      return {
        ...initialModalState,
        open: true,
        modalType: modalType(action),
      }
    case MODAL_OPEN:
      return {
        ...initialModalState,
        modalType: modalType(action),
        error: {
          open: true,
          heading: action.data.heading,
          message: action.data.message,
        },
      }
    case MODAL_CLOSE:
      return {
        ...initialModalState,
      }
    case API_CALL_SUCCESS:
      if (action.api === USER_LOGIN || action.api === USER_REGISTRATION) {
        return { ...initialModalState }
      }
      return state
    case SHOW_CHANGE_DATE_WARNING_MODAL:
    case SHOW_CHANGE_DATE_ADDON_WARNING_MODAL:
      return { ...initialModalState, open: true, modalType: modalType(action) }
    case SHOW_CUSTOMER_SIGNATURE_MODAL:
      return {
        ...initialModalState,
        open: true,
        modalType: modalType(action),
        showConfirmationOptions: !!action.showConfirmationOptions,
      }
    case ACCOMMODATION_PRICE_CHANGE_MODAL_OPEN:
      return {
        ...initialModalState,
        open: true,
        modalType: modalType(action),
        cartItemId: action.data.cartItemId,
        price: action.data.price,
        surcharge: action.data.surcharge,
        extraGuestSurcharge: action.data.extraGuestSurcharge,
      }
    case HOTEL_PRICE_CHANGE_MODAL_OPEN:
    case BUNDLE_PRICE_CHANGE_MODAL_OPEN:
    case BEDBANK_PRICE_CHANGE_MODAL_OPEN:
    case BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN:
    case TOUR_V2_PRICE_CHANGE_MODAL_OPEN:
    case JOURNEY_PRICE_CHANGE_MODAL_OPEN:
      return {
        ...initialModalState,
        open: true,
        modalType: modalType(action),
        priceChange: action.data.priceChange,
      }
    default:
      return state
  }
}

const initialAccountModalState: App.UiAccountModalState = {
  mode: undefined,
}

export const accountAccessReducer = createReducer<App.UiAccountModalState>(initialAccountModalState, {
  [API_CALL_SUCCESS]: (state, action) => {
    if (action.api === USER_LOGOUT) {
      return { mode: 'login' }
    }
    return state
  },
  [ACCOUNT_ACCESS_SHOW_LOGIN]: (state, action) => {
    return { mode: action.mode || 'login' }
  },
  [ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD]: () => ({ mode: 'forgotPassword' }),
  [ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK]: () => ({ mode: 'linkPartnership' }),
  [ACCOUNT_ACCESS_SET_MODE]: (state, action) => ({ mode: action.mode }),
})

function dropdownType(action) {
  switch (action.type) {
    case ACCOUNT_DROPDOWN_TOGGLE:
      return 'accountMenu'
    case ACCOUNT_DROPDOWN_TOGGLE_STANDALONE:
      return 'accountMenuStandalone'
    default:
      return ''
  }
}

function overlayReducer(state = initialOverlayState, action): App.UiOverlayState {
  switch (action.type) {
    case API_CALL_SUCCESS:
      if (action.api === USER_LOGIN) {
        return { ...initialOverlayState }
      }
      return state
    case ACCOUNT_DROPDOWN_TOGGLE_STANDALONE: {
      let accountDropdownOpen = true
      if (state.accountDropdownOpen && state.dropdownType === dropdownType(action)) {
        accountDropdownOpen = false
      }
      return {
        ...state,
        accountDropdownOpen,
        dropdownType: dropdownType(action),
        anyAreOpen: (state.eventsDropdownOpen || state.regionDropdownOpen || accountDropdownOpen || state.phoneDropdownOpen),
      }
    }
    case ACCOUNT_DROPDOWN_TOGGLE: {
      const accountDropdownOpen = !state.accountDropdownOpen
      return {
        ...state,
        accountDropdownOpen,
        dropdownType: dropdownType(action),
        anyAreOpen: (state.eventsDropdownOpen || state.regionDropdownOpen || accountDropdownOpen || state.phoneDropdownOpen),
      }
    }
    case REGION_DROPDOWN_TOGGLE: {
      const regionDropdownOpen = !state.regionDropdownOpen
      return {
        ...state,
        regionDropdownOpen,
        anyAreOpen: (state.eventsDropdownOpen || regionDropdownOpen || state.accountDropdownOpen || state.phoneDropdownOpen),
      }
    }
    case EVENTS_DROPDOWN_TOGGLE: {
      const eventsDropdownOpen = !state.eventsDropdownOpen
      return {
        ...state,
        eventsDropdownOpen,
        anyAreOpen: (eventsDropdownOpen || state.regionDropdownOpen || state.accountDropdownOpen || state.phoneDropdownOpen),
      }
    }
    case PHONE_DROPDOWN_TOGGLE: {
      const phoneDropdownOpen = !state.phoneDropdownOpen
      return {
        ...state,
        phoneDropdownOpen,
        anyAreOpen: (state.eventsDropdownOpen || state.regionDropdownOpen || state.accountDropdownOpen || phoneDropdownOpen),
      }
    }
    default:
      return state
  }
}

export function socialWidgetReducer(state = initialSocialWidgetState, action): App.UiSocialWidgetState {
  switch (action.type) {
    case CLOSE_SOCIAL_WIDGET:
      return {
        ...initialSocialWidgetState,
        display: false,
      }
    default:
      return state
  }
}

const initialCartState: App.UiCartState = {
  packagesOpen: false,
  packageNightsOpen: false,
  sidebarOpen: false,
}

export const cartReducer = createReducer<App.UiCartState>(initialCartState, {
  [TOGGLE_CART_PACKAGES]: (state, action) => ({
    packagesOpen: action.open,
  }),
  [TOGGLE_CART_SIDEBAR]: (state, action) => ({
    sidebarOpen: action.open,
  }),
  [TOGGLE_CART_PACKAGE_NIGHTS]: (state, action) => ({
    packageNightsOpen: action.open,
  }),
  [CART_EMPTY]: () => initialCartState,
})

const uiReducer = combineReducers<App.UiState>({
  overlay: overlayReducer,
  modal: modalReducer,
  accountAccess: accountAccessReducer,
  socialWidget: socialWidgetReducer,
  cart: cartReducer,
})

export default uiReducer
